import { FC } from 'react'
import { IInputProps } from './IInput'
import styles from './styles.module.css'

const Input: FC<IInputProps> = ({
	value,
	style,
	max,
	maxLength,
	min,
	name,
	onChange,
	type,
	required,
	placeholder,
	className,
	id,
	label,
	checked
}) => {
	return (
		<>
			{label?.length && (
				<label className={styles.label} htmlFor={id}>
					{label}
				</label>
			)}
			<input
				id={id}
				min={min}
				max={max}
				name={name}
				type={type}
				value={value}
				checked={checked}
				style={type == 'checkbox' ? { width: 18, ...style } : style}
				onChange={onChange}
				required={required}
				className={`${className} ${styles.input}`}
				maxLength={maxLength}
				placeholder={placeholder}
			/>
		</>
	)
}

export default Input
